import { createResourceStore } from './createResourceStore';

const useErrorLogStore = createResourceStore({
  endpoint: '/admin/error-logs',
  collectionKey: 'errorLogs',
  itemKey: 'errorLog',
  paginated: true,
  totalKey: 'totalErrorLogs',
  hasCreate: false,
  hasUpdate: false,
  hasFetchById: true,
  mapListParams: (page = 1, search, stage, startDate, endDate) => ({
    page,
    search,
    stage,
    startDate,
    endDate,
  }),
  methods: {
    fetch: 'fetchErrorLogs',
    delete: 'deleteErrorLog',
    fetchById: 'fetchErrorLogById',
  },
});

export default useErrorLogStore;
